import type { CatalogSkin } from '../types';

export interface SkinTierCounts {
  legendCount: number;
  grandCount: number;
  collectorCount: number;
}

export function computeSkinTierCounts(skinKeys: string[], skinsByKey: Map<string, CatalogSkin>): SkinTierCounts {
  let legendCount = 0;
  let grandCount = 0;
  let collectorCount = 0;

  for (const key of skinKeys) {
    const skin = skinsByKey.get(key);
    if (!skin) continue;
    if (skin.tier === 'legend') legendCount++;
    else if (skin.tier === 'grand_collab' || skin.tier === 'grand_series') grandCount++;
    else if (skin.tier === 'collector') collectorCount++;
  }

  return { legendCount, grandCount, collectorCount };
}
